module.exports = __webpack_public_path__ + "img/thumbmad3.9c5405ec.png";